function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyReportsOutlinedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-997.85-227.39H-162.2a3.69,3.69,0,0,1,3.69,3.69V146.2a0,0,0,0,1,0,0h-843a0,0,0,0,1,0,0V-223.7a3.69,3.69,0,0,1,3.69-3.69Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-717.06,145.3S-524,106.82-442.39,22.66c55.84-57.61,112.55-140.67,221-149.09S28.05-48.71,50.16,35.89c28.91,110.61,9.29,169.52,9.29,169.52Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.48,32.52h15v3.76h-15Zm0-7.52h15v3.76h-15ZM28.76,6.21h-15A3.77,3.77,0,0,0,10,10V40a3.75,3.75,0,0,0,3.74,3.76H36.28A3.77,3.77,0,0,0,40,40V17.48ZM36.28,40H13.72V10H26.88v9.39h9.4Z",
    style: {
      fill: "#636c75"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyReportsOutlinedIcon);
export default __webpack_public_path__ + "static/media/daily_reports_outlined_icon.29b9b49ebce582c36225fb3e2d615608.svg";
export { ForwardRef as ReactComponent };